<template>
  <div class="bookDetails-content">
    <div class="bookDetails-content-left">
      <img
        class="bookDetails-cover"
        v-if="bookData.cover"
        :src="bookData.cover"
        alt=""
      />
      <img
        class="bookDetails-cover"
        v-else
        src="@/assets/img/cmb_book_cover.png"
        alt=""
      />
      <div class="bookDetails-info">
        <h4 class="bookDetails-info-title">
          {{ bookData.name || $t("commonMsg.none") }}
        </h4>
        <p class="bookDetails-info-author">{{ bookData.author }}</p>
        <p class="bookDetails-info-publish">
          {{ $t("content.books.publisher") }}：{{
            bookData.publisher || $t("commonMsg.none")
          }}
        </p>
        <p class="bookDetails-info-date">
          {{ $t("content.books.publish_time") }}：{{
            bookData.publish_time | filterDate
          }}
        </p>
        <p class="bookDetails-info-price">￥{{ bookData.price || 0 }}</p>
        <div class="bookDetails-info-btn">
          <button class="global-button-style" @click="addBookList">
            {{ $t("content.books.addGroup") }}
          </button>
          <button
            class="global-button-style"
            v-if="
              parseInt($route.query.source) !== 4 &&
                bookData.hasOwnProperty('status')
            "
            @click="outBookList"
          >
            {{
              bookData.status === 1
                ? $t("content.books.soldOut")
                : $t("content.books.soldOn")
            }}
          </button>
        </div>
      </div>
    </div>
    <div class="bookDetails-content-right">
      <div class="bookDetails-params">
        <el-rate v-model="rate"></el-rate>
        <p class="bookDetails-params-comment">
          {{ $t("content.books.hasComment") }}600+
        </p>
        <p class="bookDetails-params-isbn">ISBN：{{ bookData.isbn }}</p>
        <p class="bookDetails-params-total">
          {{ $t("content.books.count") }}：{{ bookData.word_count }}
        </p>
        <p class="bookDetails-params-edition">
          {{ $t("content.books.edition") }}：{{ bookData.edition }}
        </p>
        <p class="bookDetails-params-format">
          {{ $t("content.books.fileFormat") }}：{{ bookData.format }}
        </p>
        <p class="bookDetails-params-size">
          {{ $t("content.books.fileSize") }}：{{ bookData.size | renderSize }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bookData: Object
  },
  data() {
    return {
      rate: 4.5
    };
  },
  methods: {
    addBookList() {
      this.$emit("addBookList");
    },
    outBookList() {
      this.$emit("outBookList");
    }
  }
};
</script>

<style lang="scss" scoped>
.bookDetails-content {
  padding: 40px 20px;
  display: flex;
  justify-content: space-between;
  .bookDetails-content-left {
    display: flex;
    flex: 1;
    .bookDetails-cover {
      width: 180px;
      min-width: 180px;
      height: 220px;
      margin-right: 20px;
      vertical-align: baseline;
    }
    .bookDetails-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .bookDetails-info-btn {
        > button:first-child {
          margin-left: 0;
        }
      }
    }
  }
  .bookDetails-content-right {
    width: 250px;
    .bookDetails-params {
      height: 140px;
      padding: 30px 0 30px 20px;
      border: 1px solid $globalBorderColor;
    }
  }
}
</style>
